import React, { useState, useRef, useEffect } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const MonthYearPicker = ({ currentMonth, currentYear, onSelect, children }) => {
   const [isOpen, setIsOpen] = useState(false);
   const [pickerYear, setPickerYear] = useState(currentYear);
   const pickerRef = useRef(null);

   useEffect(() => {
      const handleClickOutside = (event) => {
         if (pickerRef.current && !pickerRef.current.contains(event.target)) {
            setIsOpen(false);
         }
      };

      if (isOpen) {
         document.addEventListener('mousedown', handleClickOutside);
      }
      return () => {
         document.removeEventListener('mousedown', handleClickOutside);
      };
   }, [isOpen]);

   useEffect(() => {
      if (isOpen) {
         setPickerYear(currentYear);
      }
   }, [isOpen, currentYear]);

   const handleToggle = () => {
      setIsOpen(!isOpen);
   };

   const handleMonthSelect = (month) => {
      onSelect(month, pickerYear);
      setIsOpen(false);
   };

   return (
      <div className="calendar-title-wrapper" ref={pickerRef}>
         <h2 className="calendar-title calendar-title-clickable" onClick={handleToggle}>
            {children}
         </h2>
         {isOpen && (
            <div className="month-year-picker">
               <div className="picker-header">
                  <button
                     className="picker-nav-btn"
                     onClick={() => setPickerYear(pickerYear - 1)}
                  >
                     <LeftOutlined />
                  </button>
                  <span className="picker-year">{pickerYear}</span>
                  <button
                     className="picker-nav-btn"
                     onClick={() => setPickerYear(pickerYear + 1)}
                  >
                     <RightOutlined />
                  </button>
               </div>
               <div className="picker-months">
                  {MONTHS_SHORT.map((month, index) => (
                     <button
                        key={month}
                        className={`picker-month ${index === currentMonth && pickerYear === currentYear ? 'selected' : ''}`}
                        onClick={() => handleMonthSelect(index)}
                     >
                        {month}
                     </button>
                  ))}
               </div>
            </div>
         )}
      </div>
   );
};

export default MonthYearPicker;
